module.exports = __webpack_public_path__ + "static/mtb-3-f19c05f987ebbca703b6a0fcc50855e9.jpg";